// ~~ Generated. This file cannot be edited directly. Please look at libs/nx-tooling/src/generators/backoffice-project/generator.ts

import {
  PatternLibraryAreaId,
  PatternLibraryAreaRoutes,
} from '@backoffice-frontend/common'
import { SuspenseLoadingWrapper } from '@backoffice-frontend/patterns'
import { BoumRight } from '@moia-dev/moia-token-claims'
import { lazy } from 'react'

import {
  PatternLibraryAreaNavigation,
  PatternLibraryAreaNavigationIcon,
} from './PatternLibraryAreaNavigation'

const LazyPatternLibraryComponent = lazy(() => import('./PatternLibraryArea'))

const PatternLibraryComponent = () => (
  <SuspenseLoadingWrapper>
    <LazyPatternLibraryComponent />
  </SuspenseLoadingWrapper>
)

export const PatternLibraryArea = {
  id: PatternLibraryAreaId,
  requiredRight: BoumRight.AREA_PATTERN_LIBRARY,
  Icon: PatternLibraryAreaNavigationIcon,
  NavigationComponent: PatternLibraryAreaNavigation,
  route: {
    path: PatternLibraryAreaRoutes.route,
    component: PatternLibraryComponent,
  },
}
